import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    isInitialized: false,
    isAuthenticated: false,
    user: null,
    tokens: null,
    error: null,
};
const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setInitialized: (state, action) => {
            state.isInitialized = action.payload;
        },
        setUser: (state, action) => {
            state.isAuthenticated = true;
            state.user = action.payload.user;
            state.tokens = action.payload.tokens;
            state.error = null;
        },
        clearUser: (state) => {
            state.isAuthenticated = false;
            state.user = null;
            state.tokens = null;
            state.error = null;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.isAuthenticated = false;
            state.user = null;
            state.tokens = null;
        },
        updateTokens: (state, action) => {
            state.tokens = action.payload;
        },
    },
});
export const { setInitialized, setUser, clearUser, setError, updateTokens } = authSlice.actions;
export default authSlice.reducer;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectUser = (state) => state.auth.user;
export const selectTokens = (state) => state.auth.tokens;
export const selectAuthError = (state) => state.auth.error;
export const selectIsInitialized = (state) => state.auth.isInitialized;
